import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center gap-2" };
const _hoisted_2 = { class: "flex flex-col items-center gap-0.5 text-center" };
const _hoisted_3 = { class: "text-[length:var(--size-xxl)] font-[var(--weight-bold)]" };
const _hoisted_4 = { class: "text-[length:var(--size-l)] text-(--text-text-body-subtle)" };
import { ref } from "vue";
import { Button, Modal, Tooltip } from "@eudonet/opal";
import { deleteHousehold } from "../../infrastructure/api/householdApi";
import { useAppToast } from "@/shared/composables/useAppToast";
import { usePermissions } from "@/shared/composables/usePermissions";
import { getApiErrorCode } from "@/infrastructure/services/ApiErrorService";
import { logger } from "@/infrastructure/services/LoggerService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeleteHouseholdModal',
    props: /*@__PURE__*/ _mergeModels({
        householdId: {},
        householdName: {}
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["deleted"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const open = _useModel(__props, "modelValue");
        const props = __props;
        const emit = __emit;
        const { canEditOphub: canEdit, disabledTooltip } = usePermissions();
        const { toastSuccess, toastError } = useAppToast();
        const deleting = ref(false);
        const DELETE_ERROR_KEYS = {
            EntityNotFound: "contact.detail.relations.foyer.delete.errorNotFound",
        };
        async function handleDelete() {
            if (!canEdit.value)
                return;
            deleting.value = true;
            try {
                await deleteHousehold(props.householdId);
                toastSuccess("contact.detail.relations.foyer.delete.success");
                emit("deleted");
                open.value = false;
            }
            catch (err) {
                const code = getApiErrorCode(err);
                const mappedKey = code ? DELETE_ERROR_KEYS[code] : undefined;
                if (!mappedKey) {
                    logger.error("DeleteHouseholdModal: delete failed", err);
                }
                toastError(mappedKey ?? "contact.detail.relations.foyer.delete.error");
            }
            finally {
                deleting.value = false;
            }
        }
        return (_ctx, _cache) => {
            const _component_i18n_t = _resolveComponent("i18n-t");
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((open).value = $event)),
                size: "xs",
                "header-position": "center",
                "footer-position": "split",
                "show-close-button": true,
                "show-header-border": false,
                "show-footer-border": false
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex items-center justify-center w-12 h-12 rounded-lg border border-(--border-border-base-soft) bg-white" }, [
                            _createElementVNode("i", {
                                class: "ri-home-4-line text-2xl text-(--text-text-black-default)",
                                "aria-hidden": "true"
                            })
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.householdName), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("contact.detail.relations.foyer.delete.subtitle")), 1 /* TEXT */)
                        ])
                    ])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _ctx.$t('common.cancel'),
                        disabled: deleting.value,
                        onClick: _cache[0] || (_cache[0] = ($event) => (open.value = false))
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    _createVNode(_unref(Tooltip), {
                        text: _unref(disabledTooltip),
                        disabled: _unref(canEdit),
                        tabindex: !_unref(canEdit) ? 0 : undefined
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Button), {
                                variant: "error",
                                "icon-left": "ri-delete-bin-line",
                                label: _ctx.$t('contact.detail.relations.foyer.delete.confirm'),
                                loading: deleting.value,
                                disabled: !_unref(canEdit),
                                onClick: handleDelete
                            }, null, 8 /* PROPS */, ["label", "loading", "disabled"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["text", "disabled", "tabindex"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_i18n_t, {
                        keypath: "contact.detail.relations.foyer.delete.body",
                        tag: "p",
                        class: "text-[length:var(--size-l)] text-(--text-text-body) text-center leading-[var(--line-height-xxl)]"
                    }, {
                        bold1: _withCtx(() => [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("contact.detail.relations.foyer.delete.bodyBold1")), 1 /* TEXT */)
                        ]),
                        bold2: _withCtx(() => [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("contact.detail.relations.foyer.delete.bodyBold2")), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
